import React from "react";

export default function ExcluirConta() {
  return (
    <div
      style={{
        maxWidth: "900px",
        margin: "40px auto",
        padding: "30px",
        fontFamily: "Arial, sans-serif",
        lineHeight: "1.6",
      }}
    >
      <h1>Exclusão de Conta e Dados - Litoral Vips</h1>

      <p>
        Esta página explica como os usuários do aplicativo Litoral Vips podem
        solicitar a exclusão da sua conta e dos dados pessoais associados.
      </p>

      <h2>Como solicitar a exclusão da conta</h2>

      <p>
        Para solicitar a exclusão da sua conta, entre em contato com a equipe
        do Litoral Vips através do canal oficial de atendimento e informe que
        deseja excluir sua conta.
      </p>

      <p>
        No pedido, informe o nome e o e-mail ou telefone utilizados no cadastro,
        para que seja possível localizar e confirmar a conta.
      </p>

      <h2>O que será excluído</h2>

      <p>
        Após a confirmação da solicitação, poderão ser excluídos os dados
        relacionados à conta, incluindo:
      </p>

      <ul>
        <li>Nome e informações de perfil;</li>
        <li>E-mail e telefone vinculados à conta;</li>
        <li>Informações de cadastro;</li>
        <li>Dados relacionados ao perfil de motorista ou passageiro;</li>
        <li>Outros dados pessoais vinculados diretamente à conta.</li>
      </ul>

      <h2>Dados que podem ser mantidos</h2>

      <p>
        Algumas informações poderão ser mantidas pelo período necessário quando
        houver obrigação legal, regulatória, necessidade de prevenção a fraudes,
        segurança, exercício regular de direitos ou outra hipótese permitida
        pela legislação brasileira.
      </p>

      <h2>Prazo de processamento</h2>

      <p>
        A solicitação será analisada e processada após a confirmação da
        identidade do titular da conta.
      </p>

      <h2>Contato</h2>

      <p>
        Litoral Vips
        <br />
        Site: www.litoralvips.com
      </p>

      <p>
        Para solicitar a exclusão, utilize o canal oficial de atendimento
        disponibilizado pelo Litoral Vips.
      </p>

      <p>
        Última atualização: 10 de setembro de 2026.
      </p>
    </div>
  );
}